import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, value, subtitle, icon, trend, trendValue, variant = 'default' }) => {
  const variantStyles = {
    default: 'bg-card border-border',
    primary: 'bg-primary/5 border-primary/20',
    success: 'bg-success/5 border-success/20',
    warning: 'bg-warning/5 border-warning/20',
    accent: 'bg-accent/5 border-accent/20'
  };

  const iconBgStyles = {
    default: 'bg-primary/10 text-primary',
    primary: 'bg-primary/20 text-primary',
    success: 'bg-success/20 text-success',
    warning: 'bg-warning/20 text-warning',
    accent: 'bg-accent/20 text-accent'
  };

  return (
    <div className={`${variantStyles?.[variant]} border rounded-xl p-4 sm:p-5 md:p-6 smooth-transition hover:shadow-lg min-h-[120px] sm:min-h-[140px]`}>
      <div className="flex items-start justify-between mb-3">
        <div className={`${iconBgStyles?.[variant]} w-11 h-11 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center flex-shrink-0`}>
          <Icon name={icon} size={22} className="sm:w-6 sm:h-6" />
        </div>
        {trend && (
          <div className={`flex items-center gap-1 text-xs sm:text-sm font-medium ${trend === 'up' ? 'text-success' : 'text-error'}`}>
            <Icon name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} size={16} />
            <span>{trendValue}</span>
          </div>
        )}
      </div>
      <div className="space-y-1">
        <p className="text-xs sm:text-sm text-muted-foreground font-medium">{title}</p>
        <p className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-foreground data-text leading-tight">{value}</p>
        {subtitle && (
          <p className="text-xs sm:text-sm text-muted-foreground">{subtitle}</p>
        )}
      </div>
    </div>
  );
};

export default MetricsCard;